"use strict";
(function FormDialogDataProviderDefinition(global) {

  /**
  * Провайдер данных детальных разделов диалога.
  * @since 5.2.0.1600
  * @class WebAccess.components.dialogs.FormDialogDataProvider
  * @extends WebAccess.components.dataViews.BaseDataProvider
  * @property {Object} defaults конфигурация "по-умолчанию"
  */
  var FormDialogDataProvider = WA.CMP.dataViews.BaseDataProvider.extend({
    _DFMName: null,
    _form: null,
    init: function(initialState, form) {
      var me = this;
      me._form = form;      
      me._super(initialState);

      // Для сохранения состояния.
      me._dialogName = initialState.DialogName;
      me._detailSectionNumber = initialState.DetailSectionNumber;
      me._DFMName = initialState.DFMName;

      me.defaults = {}; 
      $.extend(me.defaults, initialState);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Формирует параметры запросов.
    * @method WebAccess.components.dialogs.FormDialogDataProvider#makeParams
    * @param {Object} loadOptions Параметры запроса.
    * @return {Object} Расширенные параметры запроса.
    * @since 5.2.0.1600
    */
    makeParams: function (loadOptions) {
      return this.extendDefaults(loadOptions);
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Загружает данные детального раздела.
    * @method WebAccess.components.dialogs.FormDialogDataProvider#load
    * @param {Object} loadOptions Параметры запроса.
    * @return {Deferred} Результат загрузки данных.
    * @since 5.2.0.1600    
    */
    load: function (loadOptions) {
      var me = this;
      var result = new $.Deferred();

      var operation = WA.SRV.call('/Dialogs.asmx/GetDetailsData', me.makeParams(loadOptions));
      me._form._registerOperation('load' + me._DFMName, operation);      
      operation.done(function (data) {
        result.resolve({ Rows: $.parseJSON(data) });
      }).fail(function (e) {
        WA.ready(function () {
          var severity = (e.Severity !== "-1" ? Number(e.Severity) : undefined);
          WA.CR.inlineHint.show(e, '', severity, INLINE_HINT_PRIORITY.PRIMARY);
        });
        result.resolve({ Rows: [] });
      }).always(function () {
        me._form._unRegisterOperation('load' + me._DFMName);
      });

      return result.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Загружает сохранненные настройки детального раздела из профиля пользователя.
    * @method WebAccess.components.dialogs.FormDialogDataProvider#loadState
    * @return {Deferred} Результат загрузки состояние.
    * @since 5.2.0.1600
    */
    loadState: function () {
      var me = this;
      var result = $.Deferred();

      var jTable = $('#' + me._DFMName);
      var data = jTable.data('state');
      if (data && data["InstanceID"]) {
        delete data["InstanceID"]; //В профиле может быть неактуальная ссылка
      }
      if (data && data["DetailSectionNumber"]) {
        delete data["DetailSectionNumber"];
      }
      result.resolve(data);

      return result.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Сохраняет настройки детального раздела в профиль пользователя.
    * @method WebAccess.components.dialogs.FormDialogDataProvider#saveState
    * @param {Object} loadOptions Параметры запроса.
    * @return {Deferred} Результат сохранения состояния.
    * @since 5.2.0.1600
    */
    saveState: function (loadOptions) {
      var me = this;
      var result = $.Deferred();
      clearTimeout(me._saveSateTimeout);
      var operation = WA.cache.serverCache.setItem(me._makeKey(), me.makeParams(loadOptions));
      me._form._registerOperation('saveState' + me._DFMName, operation);
      me._saveSateTimeout = setTimeout(function () {
        operation.done(function () { 
          result.resolve();
        }).fail(function () {
          result.reject();
        }).always(function () {
          me._form._unRegisterOperation('saveState' + me._DFMName);
        });
      }, 200);
      return result.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Формирует ключ для хранения настроек в профиле пользователя.
    * @method WebAccess.components.dialogs.FormDialogDataProvider#_makeKey
    * @return {String} Ключ для хранения в профиле пользователя.
    * @since 5.2.0.1600
    * @private
    */
    _makeKey: function () {
      var me = this;
      //Формат: [имя диалога, представление, номер детального раздела].
      return $.toJSON([me._dialogName, '', '' + me._detailSectionNumber]).replaceAll(' ', '');
    }
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

  });

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
  // Публичные объекты.
  global.FormDialogDataProvider = FormDialogDataProvider;
  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

})(window.WebAccess.components.dialogs);